import { Component, EventEmitter, HostListener, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { LocalStorageService } from '../../services';
import { Router } from '@angular/router';
import { LocalStorage, Paths } from '../../enums';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'antim-autoware-side-nav',
  standalone: false,
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.scss'
})
export class SideNavComponent implements OnInit {

  @Input() isMenuOpen = true;
  @Output() menuToggle: EventEmitter<any> = new EventEmitter();
  innerWidth: number = 0;
  isBrowser = false;

  adminMenuData: any = [
    // {
    //   "application_menu_id": 1,
    //   "menu_name": "Users",
    //   "mat_icon": "group",
    //   // "screen_type": "DETAIL",
    //   "screen_type": "OVERVIEW",
    //   "menu_url": `${Paths.admin}/${Paths.users}`,
    //   // "menu": [
    //   //   {
    //   //     "application_sub_menu_id": 1,
    //   //     "menu_name": "User",
    //   //     "menu_url": `${Paths.admin}/${Paths.users}`,
    //   //   },
    //   // ]
    // },
    {
      "application_menu_id": 1,
      "menu_name": "Dashboard",
      "mat_icon": "dashboard",
      "screen_type": "OVERVIEW",
      "menu_url": `${Paths.admin}/${Paths.admin}/${Paths.dashboard}`,
    },
    {
      "application_menu_id": 2,
      "menu_name": "Gallery",
      "mat_icon": "collections_bookmark",
      "screen_type": "OVERVIEW",
      "menu_url": `${Paths.admin}/${Paths.galleryCategory}`,
    },
    {
      "application_menu_id": 3,
      "menu_name": "Courses",
      "mat_icon": "school",
      "screen_type": "OVERVIEW",
      "menu_url": `${Paths.admin}/${Paths.courseCategory}`,
    },
    {
      "application_menu_id": 4,
      "menu_name": "Courses Inquiry",
      "mat_icon": "assignment",
      "screen_type": "OVERVIEW",
      "menu_url": `${Paths.admin}/${Paths.coursesinquiry}`,
    },
    {
      "application_menu_id": 6,
      "menu_name": "Banners",
      "mat_icon": "list",
      "screen_type": "OVERVIEW",
      "menu_url": `${Paths.admin}/${Paths.banners}`,
    },
    {
      "application_menu_id": 5,
      "menu_name": "Logout",
      "mat_icon": "logout",
      "screen_type": "OVERVIEW",
    },
  ];
  menuData: any = [];

  applicationMenuId = 0;
  applicationSubMenuId = 0;

  constructor(private localStorageService: LocalStorageService, private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    const switchType = "Admin";
    switch (switchType) {
      case "Admin":
        this.menuData = this.adminMenuData;
        break;
      default:
        this.menuData = this.adminMenuData;
        break;
    }

    this.applicationMenuId = parseInt(this.localStorageService.getData(LocalStorage.applicationMenuId));
    this.applicationSubMenuId = parseInt(this.localStorageService.getData(LocalStorage.applicationSubMenuId));
    if (this.applicationMenuId === 0 || isNaN(this.applicationMenuId)) {
      this.router.events.subscribe((event: any) => {
        if (event.url) {
          for (const key in this.menuData) {
            const element = this.menuData[key];
            if (element.menu_url === event.url) {
              this.applicationMenuId = element.application_menu_id;
              this.applicationSubMenuId = 0;
              break;
            }
            else if (element.screen_type === "DETAIL" && element.menu.length !== 0) {
              for (const key in element.menu) {
                const subElement = element.menu[key];
                if (subElement.menu_url === event.url) {
                  this.applicationMenuId = element.application_menu_id;
                  this.applicationSubMenuId = subElement.application_sub_menu_id;
                  break;
                }
              }
            }
          }
        }
      });
    }
    // this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.innerWidth = window.innerWidth;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth = window.innerWidth;
  }

  onHideShow(): void {
    this.menuToggle.emit(!this.isMenuOpen);
  }

  menuClick(menuItem: any) {
    if (menuItem.menu_name === 'Logout') {
      this.localStorageService.deleteData(LocalStorage.accessToken);
      this.localStorageService.deleteData(LocalStorage.loginData);
      this.localStorageService.deleteData(LocalStorage.loginDatas);
      this.localStorageService.deleteData(LocalStorage.applicationMenuId);
      this.localStorageService.deleteData(LocalStorage.applicationSubMenuId);
      this.localStorageService.deleteData(LocalStorage.routerPath);
      this.router.navigate(["/" + Paths.admin + "/" + Paths.authentication + "/" + Paths.adminLogin]);
      return;
    }
    if (menuItem.screen_type === "DETAIL" && menuItem.menu && menuItem.menu.length > 0) {
      this.applicationMenuId = this.applicationMenuId === menuItem.application_menu_id ? "" : menuItem.application_menu_id;
    } else {
      this.openMenu(menuItem.application_menu_id, menuItem.menu_url, true);
    }
  }

  openMenu(mainMenuId: any, url: any, isMainMenu = false) {
    if (isMainMenu) {
      this.applicationMenuId = mainMenuId;
      this.applicationSubMenuId = 0;
      this.localStorageService.setData(LocalStorage.applicationMenuId, mainMenuId + "");
      this.localStorageService.setData(LocalStorage.applicationSubMenuId, "0");
    }
    else {
      this.applicationSubMenuId = mainMenuId;
      this.localStorageService.setData(LocalStorage.applicationMenuId, this.applicationMenuId + "");
      this.localStorageService.setData(LocalStorage.applicationSubMenuId, mainMenuId + "");
    }
    this.router.navigate([url]);
    if (innerWidth <= 991.98) {
      this.menuToggle.emit(false);
    }
  }

  goToHomePage() {
    this.router.navigate(["/" + Paths.admin + "/" + Paths.admin + "/" + Paths.dashboard]);
  }
}
